import UAParser from 'ua-parser-js'

import { useSatuEventTracker } from 'utils/satuEvent'
import { enabledAssessmentTrackers } from '../data'
import { SATU_EVENT_CONFIG } from 'configs/auth'
import { getSession } from 'utils/auth'
import { useAssessmentTrackerStore } from 'stores/tracker'
import { useMetaDataStore } from 'stores/metadata'

import type { SETrackEventArgs } from 'utils/satuEvent'

function useSatuEventAssessment() {
  const { SETrackEvent } = useSatuEventTracker({ mode: 'mengajar' })
  const { eventTrigger, eventTriggerId } = useAssessmentTrackerStore()
  const ip = useMetaDataStore((state) => state.ip)
  const session = getSession()
  const ua = UAParser()
  const { debugEnabled } = SATU_EVENT_CONFIG

  const SETrackEventAssessment = ({
    eventName,
    eventParams,
    ...props
  }: SETrackEventArgs) => {
    if (!enabledAssessmentTrackers.includes(eventName)) {
      if (debugEnabled) {
        // eslint-disable-next-line no-console
        console.log(`[SatuEvent DISABLED] ${eventName} `)
      }
      return
    }

    return SETrackEvent({
      eventName,
      eventParams: {
        teacher_email: session?.user?.email,
        referrer_url: document.referrer,
        device_model: ua?.device?.model,
        internet_connection:
          (window?.navigator as any)?.connection?.effectiveType || 'unknown',
        ...(ip ? { ip } : {}),
        ...(eventTrigger ? { event_trigger: eventTrigger } : {}),
        ...(eventTriggerId ? { event_trigger_id: eventTriggerId } : {}),
        ...(props.sendUserAgent ? { user_agent: ua?.ua } : {}),
        ...eventParams,
      },
      ...props,
    })
  }

  return { SETrackEventAssessment }
}

export default useSatuEventAssessment
